import SystemSetting from "@/models/SystemSetting";
import { IApiClient, getApiClient } from "./ApiClient/ApiClient";
import logger, { LoggingSource } from "@/shared/Logger";
import IResponseModel from "./ResponseModel";

export default class SystemSettingApi {
  private readonly _apiClient: IApiClient;
  private readonly URL = "/systemsetting";

  constructor(apiClient: IApiClient = getApiClient()) {
    this._apiClient = apiClient;
  }

  async getSystemSetting(): Promise<IResponseModel<SystemSetting>> {
    try {
      logger.info("getSystemSetting...", LoggingSource.UISystemSetting);

      logger.timeStart("getSystemSetting call", LoggingSource.UISystemSetting);

      const result = await this._apiClient.get<SystemSetting>(this.URL);

      logger.timeEnd("getSystemSetting call", LoggingSource.UISystemSetting);

      logger.debug(
        `getSystemSetting response: ${JSON.stringify(result)}`,
        LoggingSource.UISystemSetting
      );
      return result;
    } catch (error) {
      logger.timeEnd("getSystemSetting call", LoggingSource.UISystemSetting);
      logger.error(JSON.stringify(error), LoggingSource.UISystemSetting);

      throw error;
    } finally {
      logger.info("...getSystemSetting", LoggingSource.UISystemSetting);
    }
  }

  async getPublicKey() {
    try {
      logger.info("getPublicKey...", LoggingSource.UISystemSetting);

      logger.timeStart("getPublicKey call", LoggingSource.UISystemSetting);

      const result = await this._apiClient.get<string>(
        `${this.URL}/publicapikey`
      );

      logger.timeEnd("getPublicKey call", LoggingSource.UISystemSetting);

      logger.debug(
        `getPublicKey response: ${JSON.stringify(result)}`,
        LoggingSource.UISystemSetting
      );
      return result;
    } catch (error) {
      logger.timeEnd("getPublicKey call", LoggingSource.UISystemSetting);
      logger.error(JSON.stringify(error), LoggingSource.UISystemSetting);

      throw error;
    } finally {
      logger.info("...getPublicKey", LoggingSource.UISystemSetting);
    }
  }
}
